import { Employee } from '../../../types';

export const getQuickCrewPrintHtml = (selectedEmployeesData: Employee[]): string => `
<html>
  <head>
    <title>Quick Crew List</title>
    <style>
      body { 
        font-family: 'Arial', sans-serif; 
        padding: 20px; 
        line-height: 1.6; 
      }
      .header { 
        text-align: center; 
        margin-bottom: 30px; 
        border-bottom: 2px solid #333;
        padding-bottom: 20px;
      }
      .company-name { 
        font-size: 24px; 
        font-weight: bold; 
        color: #2563eb; 
        margin-bottom: 10px;
      }
      .document-title { 
        font-size: 20px; 
        font-weight: bold; 
        margin-bottom: 5px;
      }
      .date { 
        font-size: 14px; 
        color: #666; 
      }
      table { 
        width: 100%; 
        border-collapse: collapse; 
        margin: 20px 0; 
        font-size: 12px;
      }
      th, td { 
        border: 1px solid #ddd; 
        padding: 8px; 
        text-align: left; 
      }
      th { 
        background-color: #f8f9fa; 
        font-weight: bold;
        color: #333;
      }
      tr:nth-child(even) {
        background-color: #f8f9fa;
      }
      .footer {
        margin-top: 40px;
        text-align: center;
        font-size: 12px;
        color: #666;
        border-top: 1px solid #ddd;
        padding-top: 20px;
      }
      @media print { 
        body { margin: 0; } 
        .no-print { display: none; }
      }
    </style>
  </head>
  <body>
    <div class="header">
      <div class="company-name">Petromarine ERP</div>
      <div class="document-title">Quick Active Crew List</div>
      <div class="date">Print Date: ${new Date().toLocaleDateString()}</div>
    </div>
    <table>
      <thead>
        <tr>
          <th>Employee Code</th>
          <th>Name</th>
          <th>Position</th>
          <th>Department</th>
          <th>National ID</th>
          <th>Phone</th>
          <th>Seaman Book</th>
          <th>Book Expiry</th>
        </tr>
      </thead>
      <tbody>
        ${selectedEmployeesData.map(emp => `
          <tr>
            <td>${emp.code}</td>
            <td>${emp.name}</td>
            <td>${emp.position}</td>
            <td>${emp.department || 'N/A'}</td>
            <td>${emp.nationalId}</td>
            <td>${emp.phoneNumber}</td>
            <td>${emp.seamanBookNumber || 'N/A'}</td>
            <td>${emp.seamanBookExpiry ? new Date(emp.seamanBookExpiry).toLocaleDateString() : 'N/A'}</td>
          </tr>
        `).join('')}
      </tbody>
    </table>
    <div class="footer">
      <p>Total Employees: ${selectedEmployeesData.length}</p>
      <p>Generated by Petromarine ERP System - ${new Date().toLocaleString()}</p>
    </div>
  </body>
</html>
`;
